import { render, staticRenderFns } from "./AsideCore.vue?vue&type=template&id=79240205&scoped=true&"
import script from "./AsideCore.vue?vue&type=script&lang=js&"
export * from "./AsideCore.vue?vue&type=script&lang=js&"
import style0 from "./AsideCore.vue?vue&type=style&index=0&id=79240205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79240205",
  null
  
)

export default component.exports